export class M3FTrabajo{
    public IdHub:number;
    public IdUbic:number;
    public IdHubPre:number;
    public IdUbicPre:number;
}